module.exports = __webpack_public_path__ + "img/pick3.2b925710.png";